import ThemesFeature from './ThemesFeature';

const FEATURE_ARTICLES = {
  themes: ThemesFeature,
};

export function getFeatureArticle(slug) {
  return FEATURE_ARTICLES[slug] || null;
}
